import EventBus from '../services/service.eventBus';
import { getIsOptimizelyTrue } from '../services/service.optimizely';
import { state as exteriorState } from '../store/store.exterior';
import { state as interiorState } from '../store/store.interior';
import { state as mechanicalState } from '../store/store.mechanical';
import { state as vehicleConditionsState } from '../store/store.vehicle-conditions';
import {
  getIssuesResponseData,
  tabToEventElement,
  trackConditionTabSelection,
  trackConditionTierModalCancel,
  trackConditionTierModalConfirm,
  trackExteriorClick,
} from '../tracking/tracking.conditions';
import { QUESTION_CONDITION_TIER_SELECTION } from '../utils/utils.question';

import { onQuestionAnswered } from './actions.answers';

const isDescriptionOpen = (event: Object) => {
  if (event && event['eventResult'] && event['eventResult'].includes('see-condition-descriptions')) {
    vehicleConditionsState.isDescriptionOpen = true;
  } else {
    vehicleConditionsState.isDescriptionOpen = false;
  }
};

const loadKBBLibrary = () => {
  const script = document.createElement('script');
  script.src = 'https://use1-owners-webcomponents-node-master.awskbbowners.kbb.com/build/node.esm.js';
  script.async = true;
  script.type = 'module';
  document.body.appendChild(script);
};

export const onConditionTabSelected = (key: string) => {
  const previousTab = vehicleConditionsState.currentTab;
  updateSelectedConditionTab(key);
  trackConditionTabSelection(key, previousTab);
  if (key === 'exterior') {
    trackExteriorClick(previousTab);
  }
};

export const updateSelectedConditionTab = (value: string) => {
  vehicleConditionsState.currentTab = tabToEventElement[value];
};

const onConditionTierSelected = (event: object) => {
  vehicleConditionsState.conditionTierSelection = event['condition'];
};

export const onConditionTierConfirmed = () => {
  if (vehicleConditionsState.conditionTierSelection) {
    onQuestionAnswered(QUESTION_CONDITION_TIER_SELECTION, vehicleConditionsState.conditionTierSelection);
    // Temporary, until KBB takes back control of navigation
    window.location.href = vehicleConditionsState.leadFormUrl;
    trackConditionTierModalConfirm();
  }
};

export const onModalCancel = () => {
  EventBus.publish('ConditionTierNotSelected', { form: 'vehicle-conditions-form' });
  trackConditionTierModalCancel();
};

const onOptimizelyCheck = async () => {
  try {
    await onOptimizelyCheckSuccess();
  } catch (error) {
    onOptimizelyCheckFail(error);
  }
};

const onOptimizelyCheckSuccess = async () => {
  EventBus.publish('OptimizelyCheck', 'ConditionTier');

  const ret = await getIsOptimizelyTrue('conditiontierselection', 'useConditionTierSelection');
  vehicleConditionsState.optimizelyConditionTierSelectionIsActive = ret.data.variableValue;

  EventBus.publish('OptimizelyConditionTierCheckSuccess', ret);
};

const onOptimizelyCheckFail = (error) => {
  EventBus.publish('OptimizelyConditionTierCheckFail', error);
};

export const onVehicleConditionInit = ({ formSubmitted, leadFormUrl, showConditionTierAlert }) => {
  vehicleConditionsState.formSubmitted = formSubmitted;
  vehicleConditionsState.leadFormUrl = leadFormUrl;
  vehicleConditionsState.showConditionTierAlert = showConditionTierAlert;
  onOptimizelyCheck();
  loadKBBLibrary();
  EventBus.subscribe('TrackingEvent', isDescriptionOpen);
  EventBus.subscribe('ConditionSelected', onConditionTierSelected);
};

export const onVehicleConditionUnloaded = () => {
  EventBus.unsubscribe('TrackingEvent', isDescriptionOpen);
  EventBus.unsubscribeAll('ConditionSelected');
};

export const onVehicleConditionUpdate = ({ formSubmitted, leadFormUrl, showConditionTierAlert }) => {
  vehicleConditionsState.formSubmitted = formSubmitted;
  vehicleConditionsState.leadFormUrl = leadFormUrl;
  vehicleConditionsState.showConditionTierAlert = showConditionTierAlert;
  validateForm();
  shouldShowModal();
};

const publishFormStatus = (isValid: boolean) => {
  EventBus.publish('FormValidated', { form: 'vehicle-conditions-form', isValid });
};

const publishYesItsPerfectConditionForm = (isConditionValid: boolean) => {
  EventBus.publish('ConditionFormValidated', {
    form: 'vehicle-conditions-form',
    isConditionValid,
    currentTab: vehicleConditionsState.currentTab,
    ...getIssuesResponseData({ exteriorState, interiorState, mechanicalState }),
  });
};

const shouldShowModal = () => {
  if (vehicleConditionsState.optimizelyConditionTierSelectionIsActive && vehicleConditionsState.isConditionPerfect && vehicleConditionsState.formSubmitted) {
    vehicleConditionsState.showModal = true;
  } else {
    vehicleConditionsState.showModal = false;
  }
};

export const validateForm = () => {
  if (vehicleConditionsState.optimizelyConditionTierSelectionIsActive) {
    publishFormStatus(!vehicleConditionsState.isConditionPerfect);
  }
  publishYesItsPerfectConditionForm(!vehicleConditionsState.isConditionPerfect);
};
